import React from 'react';

const WhatsappIntegrations = () => {
  return <div>hi WhatsappIntegrations</div>;
};

export default WhatsappIntegrations;
